import { useGlobalContext } from '../context';
import React from 'react';

const TestQuestion = (props) => {
  const {
    answerStates,
    setAnswerStates,
    setScore,
    score,
    userInfo,
    setUserInfo,
  } = useGlobalContext();
  //const [score, setScore] = React.useState(0)

  const setUserInfoHandler = (newScore) => {
    if (localStorage.getItem('score')) {
      localStorage.removeItem('score');
    }
    localStorage.setItem('score', JSON.stringify(newScore));
    if (userInfo) {
      setUserInfo((prevInfos) => {
        return { ...prevInfos, score: newScore };
      });
      localStorage.removeItem('userInfo');
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  };

  const checkAnswer = (item, itemToCompare, index) => {
    if (item === itemToCompare) {
      // console.log('correct');
      setUserInfoHandler(score + 1);
      setScore((prevScore) => prevScore + 1);

      setAnswerStates((prevArray) => {
        return prevArray.map((it, ind) => {
          return ind === index ? 'correct' : it;
        });
      });
    } else {
      setUserInfoHandler(score - 1);
      setScore((prevScore) => prevScore - 1);

      setAnswerStates((prevArray) => {
        return prevArray.map((it, ind) => {
          return ind === index ? 'wrong' : it;
        });
      });
    }
  };

  const checkAnswerHandler = (e, item, index) => {
    e.preventDefault();
    // console.log(item, index);
    if (props.engJap) {
      checkAnswer(item, props.question.jap, index);
    } else {
      checkAnswer(item, props.question.eng, index);
    }
  };

  return (
    <div className="flex letter-spacing-2 " style={{ flexDirection: 'column' }}>
      <h5 style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
        {props.engJap ? props.question.eng : props.question.jap}
      </h5>
      <section className="grid">
        {props.answers.map((item, index) => {
          return (
            <div
              className="answer"
              onClick={(e) => checkAnswerHandler(e, item, index)}
              key={index}
              style={{
                pointerEvents:
                  answerStates[index] === 'normal' ? 'auto' : 'none',
                backgroundColor:
                  answerStates[index] === 'normal'
                    ? 'hsl(var(--clr-light))'
                    : answerStates[index] === 'correct'
                    ? 'green'
                    : 'red',
              }}
            >
              {item}
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default TestQuestion;
